import React, { useRef, useEffect, createContext, useContext } from 'react';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';

const LastLocationContext = createContext(null);

export const LastLocationProvider = ({ children }) => {
  const location = useLocation();
  const lastLocationRef = useRef(null);
  const currentLocationRef = useRef(location);

  useEffect(() => {
    // Save the previous location before updating current
    lastLocationRef.current = currentLocationRef.current;
    currentLocationRef.current = location;
  }, [location]);

  return (
    <LastLocationContext.Provider value={lastLocationRef.current}>
      {children}
    </LastLocationContext.Provider>
  );
};

LastLocationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useLastLocation = () => {
  const lastLocation = useContext(LastLocationContext);
  return lastLocation;
};
